import React, { useState, useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import { ModalHeader, ModalBody, ModalFooter, Button, FormFeedback } from 'reactstrap'

import Icon from 'e-submission/components/Icon'
import Dialog from 'e-submission/components/Dialog'
import { getFileWithName } from 'e-submission/apps/selectors'
import { showSignPad, loadDocument } from 'e-submission/apps/actions'
import { Tab } from 'common-components'
import { getToggles } from 'quick-quote/feature-toggles'

import viewerUrl from 'file-loader?name=pdf-viewer/web/viewer.html&emitFile=false!e-submission/pdf-viewer/web/viewer.html'

const PdfViewer = styled.iframe`
  transition: opacity 0.2s ease-in-out;
  opacity: ${({ loading }) => (loading ? 0 : 1)};
`

const onLoadIframe = async (evt, doc) => {
  return new Promise((resolve) => {
    const iframe = evt.target
    const iframeDocument = iframe.contentWindow.document
    const toolbar = iframeDocument.querySelector('.toolbar')
    const content = iframeDocument.querySelector('#viewerContainer')

    toolbar.style.visibility = 'hidden'
    content.style.top = 0

    iframeDocument.body.setAttribute('data-doc-name', doc.name)
    iframeDocument.body.setAttribute('data-readonly', doc.readOnly && doc.readOnly.toString())
    if (getToggles().ENABLE_ECBR_WATERMARK) {
      iframeDocument.body.setAttribute('data-watermark', 'true')
    }
    resolve()
  })
}

const getActionMessage = (document) => {
  return `${PERSON_MAP[document.person]} อ่านเอกสารครบถ้วน สามารถลงนามได้ทันที`
}

const getActionButtonLabel = (document) => {
  const isDocumentChecked = document.checked
  return !isDocumentChecked ? document.sectionLabel : `แก้ไข ${document.sectionLabel}`
}

const isReadAll = (read) => getToggles().SHORTCUT_SINGLE_SIGN || !Object.values(read).includes(false)

const PERSON_MAP = {
  insured: 'ผู้เอาประกันภัย',
  payer: 'ผู้ชำระเบี้ย',
  agent: 'ตัวแทน/นายหน้าประกันชีวิต',
}

export const Component = (props) => {
  const { toggle, className, isOpen, hideDialog, document } = props
  const dispatch = useDispatch()

  const [currentDocName, setCurrentDocName] = useState(document.name)
  const [read, _setRead] = useState(
    document.checked ||
      document.allDocuments.reduce(
        (map, { name }) => ({
          ...map,
          [name]: name === document.name,
        }),
        {}
      )
  )

  const setRead = (docName) => {
    _setRead((state) => ({
      ...state,
      [docName]: true,
    }))
  }

  const [signed, setSigned] = useState(document.checked)
  const [loading, setLoading] = useState(false)

  const currentDocIndex = document.allDocuments.findIndex((d) => d.name === currentDocName)
  const totalDoc = document.allDocuments.length

  const url = useSelector((state) => getFileWithName(state, currentDocName))

  const onloadDocument = (docName) => {
    dispatch(loadDocument(docName))
  }

  const handleTabClick = (docName) => {
    onloadDocument({ ...document, name: docName })
    setLoading(true)
    setTimeout(() => {
      setCurrentDocName(docName)
      setRead(docName)
    }, 700)
  }

  const onIFrameLoad = async (e) => {
    await onLoadIframe(e, document)
    setLoading(false)
  }

  const onSign = () => {
    dispatch(showSignPad(document))
  }

  return (
    <Dialog
      toggle={toggle}
      className={[
        className,
        'az-dialog--preview-multiple-pdf',
        Object.values(read).some((v) => !v) ? '' : 'az-dialog--preview-multiple-pdf--opened-all',
        !signed ? '' : 'az-dialog--preview-multiple-pdf--signed',
      ].join(' ')}
      isOpen={isOpen}
    >
      <ModalHeader>
        <div className="action action--left">
          <div className="btn-left" onClick={hideDialog}>
            <Icon.arrowLeft className="icon" />
          </div>
        </div>
        <div className="title">
          เอกสาร {currentDocIndex + 1} จาก {totalDoc}
        </div>
        <div className="action action--right" />
      </ModalHeader>
      <Tab active={currentDocName} onChange={handleTabClick}>
        {document.allDocuments.map((d) => (
          <Tab.Item id={d.name} key={d.name} className={read[d.name] || document.checked ? 'highlight' : ''}>
            <span className="title-text">
              <span className="icon" />
              {d.shortText || d.text}
            </span>
          </Tab.Item>
        ))}
      </Tab>
      <ModalBody className={`modal-body--pdf-view modal-body--pdf-view--${currentDocName}`}>
        {url && <PdfViewer loading={loading} src={`${viewerUrl}?file=${url}`} onLoad={onIFrameLoad} />}
      </ModalBody>
      {document.readOnly ? null : (
        <ModalFooter>
          <div className="form-group">
            <FormFeedback className="info-message attached-icon">
              <p>{getActionMessage(document)}</p>
            </FormFeedback>
          </div>

          <Button color={!isReadAll(read) ? 'disabled' : 'primary'} onClick={onSign} disabled={!isReadAll(read)}>
            {getActionButtonLabel(document)}
          </Button>
        </ModalFooter>
      )}
    </Dialog>
  )
}

const PreviewMultiplePDF = Component

export default PreviewMultiplePDF
